import { useAuth } from "@/context/AuthContext";

/** Permisos del usuario conectado, tal como los devuelve el backend en /auth/me. */
export const usePermisos = () => {
  const { user } = useAuth();
  const lista = user?.permisos || [];
  return {
    permisos: lista,
    rol: user?.rol,
    puede: (...claves) => claves.some((c) => lista.includes(c)),
  };
};
